import { PaginationBody } from '@Entities/pagination'
import { searchSongwriterCatalog } from '@App/api/routes/songwriter/songwriter'
import { SidebarDownloadType } from '@App/enum/sidebar-download-type'
import SearchCriteriaStore from '@App/stores/search/search-criteria-store'
import { SearchOptionType } from '@App/enum/search-option-type'
import { RequiredCriteria } from '@App/enum/required-criteria'
import { SearchCriterion } from '@App/stores/search/models/search-criterion'
import { WorkSearch } from '@App/stores/search/models/work-search'
import { generateSearchCriterionFromOption } from '@App/helpers/generate-search-criterion'
import CatalogSearchStore from '@App/stores/search/work/catalog-search-store'
import { SelectOptionHide } from '@App/stores/search/models/select-option-hide'
import { v4 as uuidv4 } from 'uuid'
import getWorkAutoCompleteSuggestions from '@App/helpers/search/get-work-autocomplete-suggestions'
import { ALPHABETICAL_WORK_TITLE_SORT } from '@App/const/pagination'
import { Works } from '@Entities/work/works'

export const SEARCH_SONGWRITER_CATALOG_WORK_OPTIONS: Array<SelectOptionHide<WorkSearch>> = [
    {
        id: uuidv4(),
        value: 'combinedTitles',
        label: 'Song Title',
        isPrimary: true,
        autoCompleteFetcher: ({ searchTerm, rightsholderId, songwriterId, signal }) =>
            getWorkAutoCompleteSuggestions({
                property: 'combinedTitles',
                searchTerm,
                rightsholderId,
                songwriterId,
                signal,
            }),
        exactMatchOnly: true,
    },
    { id: uuidv4(), value: 'writerFullNames', label: 'Co-writer', exactMatchOnly: true },
    { id: uuidv4(), value: 'writerNameNumbers', label: 'Co-writer IPI' },
    { id: uuidv4(), value: 'originalPubNames', label: 'Publisher', exactMatchOnly: true },
    { id: uuidv4(), value: 'recordingArtists', label: 'Recorded By' },
    { id: uuidv4(), value: 'recordingTitles', label: 'Recording Title' },
]
export const defaultSongwriterCatalogSelectionCriteria: Array<SearchCriterion<WorkSearch>> = [
    generateSearchCriterionFromOption(SEARCH_SONGWRITER_CATALOG_WORK_OPTIONS[0], true),
    generateSearchCriterionFromOption(SEARCH_SONGWRITER_CATALOG_WORK_OPTIONS[1], true),
]

export default class SongwriterCatalogSearchStore extends CatalogSearchStore {
    public async fetchWorks(pagination: PaginationBody, search?: WorkSearch): Promise<Works> {
        if (!search) {
            pagination.sort = ALPHABETICAL_WORK_TITLE_SORT
        }
        const response = await searchSongwriterCatalog(
            this.rootStore.songwriterStore.currentSongwriterId,
            pagination,
            search
        )

        return {
            count: response.data.totalElements,
            works: response.data.content,
            error: undefined,
        }
    }

    protected loadRelatedData(): void {
        // Songwriter catalog results do not display rightsholder claimed shares.
    }

    get sidebarDownloadType(): SidebarDownloadType {
        return SidebarDownloadType.SongwriterCatalogExport
    }

    get searchScopeKey(): unknown[] {
        return ['songwriter-catalog', this.rootStore.songwriterStore.currentSongwriterId]
    }

    public resetSearchCriteriaStore() {
        const maxCriteria = 6
        this.searchCriteriaStore = new SearchCriteriaStore(
            defaultSongwriterCatalogSelectionCriteria,
            SEARCH_SONGWRITER_CATALOG_WORK_OPTIONS,
            SearchOptionType.primary,
            RequiredCriteria.primaryFilter,
            maxCriteria
        )
    }
}
